import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/dist/vuetify.min.css';
import Vue from 'vue';
import Vuetify from 'vuetify';
import en from '@/locale/en';
import es from '@/locale/es';
import { getTheme } from '@/themes';
import systemB from '@/themes/system-b';
import { readPersistedTheme } from '@/themes/apply';

import customIcons from '@/components/icons/index';

Vue.use(Vuetify, { iconfont: 'mdi' });

// Lee el tema activo para sincronizar el primary de Vuetify con el accent del tema.
// Sin esto, sliders, switches, botones "primary" y demás componentes Vuetify
// se pintarian con el violeta legacy (#7C6DF0) independientemente del tema.
// Merge del Sistema B (taxonomía invariante) con el tema activo, mismo
// orden que apply.js: B primero, tema después (el tema override gana).
// statusOnline/statusAlert/statusOffline/alertInfo viven en Sistema B.
const activeTheme = { ...systemB, ...getTheme(readPersistedTheme()) };
const isLightTheme = !!activeTheme.isLight;

// Paleta Vuetify derivada del tema activo (primary = accent del tema, etc.).
// Se usa como modo light si el tema es claro, o como modo dark si es oscuro.
const themePalette = {
  primary: activeTheme.accent,
  secondary: '#6B7A8D',
  accent: activeTheme.accent,
  success: activeTheme.statusOnline,
  warning: activeTheme.statusAlert,
  error: activeTheme.statusOffline,
  info: activeTheme.alertInfo,
  mattBlack: '#424242'
};

export default new Vuetify({
  lang: {
    locales: { es, en },
    current: 'es',
  },
  icons: {
    values: {
      ...customIcons
    },
  },
  theme: {
    // Modo light cuando el tema activo es claro (diurno). Sin esto, los
    // componentes Vuetify (v-text-field, v-list-item, v-select, date
    // pickers, tabs) usan sus defaults dark = texto blanco, que sobre los
    // fondos claros del tema queda invisible. Los 4 temas oscuros mantienen
    // dark:true (comportamiento sin cambios).
    dark: !isLightTheme,
    options: {
      customProperties: true,
    },
    themes: {
      light: isLightTheme ? themePalette : {
        primary: '#00ae87',
        secondary: '#424242',
        accent: '#4f7dd1',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        mattBlack: '#424242'
      },
      dark: themePalette,
    },
  },
});

// 38
// 67
// 121

// 60
// 105
// 91
